import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const Message = styled.div `
  ${typeStyle("bodyS")};
  display: flex;
  margin-top: ${units(1)};
  color: ${color("typeBody")};
  align-items: center;

  > svg {
    color: ${color("base")};
    margin-right: ${units(0.5)};
    position: relative;
    top: -1px;
  }
`;
